import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {BettingCenter} from '../betting-center.js';

import {yourBetsFactory} from './your-bets.factory';

import PALETTE_SCHEMA from './your-bets.palette-schema.yaml';

class YourBetsFeature extends AbstractVisualFeature {
    get name() {
        return 'YourBets';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return yourBetsFactory(PALETTE);
    }
}

new YourBetsFeature(BettingCenter);
